import { installChallengeGate, installRecovery } from './lib/fastly-recovery/browser';

// Install the gate first so recovery can own challenge preparation before each guarded dispatch.
installChallengeGate(window);
installRecovery(window);

export function onRouterTransitionStart(): void {
  window.fastlyActionRecovery?.navigate();
}
